import { supabase } from "../supabaseClient";
import { Diary, MoodType } from "../types/appTypes";

/** ✔ 특정 날짜의 일기 불러오기 */
export async function getDiary(
  user_id: string,
  date: string
): Promise<Diary | null> {
  const { data, error } = await supabase
    .from("diaries")
    .select("*")
    .eq("user_id", user_id)
    .eq("date", date)
    .maybeSingle();

  // 일기 없음(PGRST116)은 정상 케이스
  if (error && error.code !== "PGRST116") {
    console.error("getDiary error:", error);
    throw error;
  }

  return data ?? null;
}

/** ✔ 유저가 작성한 모든 일기 날짜 목록 */
export async function getDiaryDates(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from("diaries")
    .select("date")
    .eq("user_id", userId);

  if (error) {
    console.error("getDiaryDates error:", error);
    throw error;
  }

  // 혹시 모를 중복 제거
  return Array.from(new Set(data.map(d => d.date)));
}

/** ✔ 일기 저장 (UPSERT) */
export async function saveDiary(
  id: number | null,       // ← 유지 (지금은 내부적으로 안 씀)
  user_id: string,
  date: string,
  mood: MoodType,
  text: string
): Promise<Diary> {
  const payload = {
    user_id,
    date,
    mood,
    text,
  };

  const { data, error } = await supabase
    .from("diaries")
    .upsert(payload, {
      onConflict: "user_id,date",
    })
    .select()
    .single();

  if (error) {
    console.error("saveDiary error:", error);
    throw error;
  }

  return data;
}
